import React, { useEffect, useState } from "react";
import { RiDeleteBin4Line } from 'react-icons/ri'
import { notificationService } from "services/notification.service";
import useCurrentUser from "hooks/useCurrentUser";
import { getFormattedDate } from "utils";
import { Link, useNavigate } from "react-router-dom";
import star from "../../assets/images/star.svg";
import deafultuserImg from "assets/images/avatar.svg";
import DeleteAlert from "components/Modals/Alertpopus/DeleteAlert";
import DeleteNotification from "components/Modals/DeleteNotification";
import arrowLeft from "../../assets/images/arrow-leftttttt.svg";
import parse from "html-react-parser";
import useNotificationList from "hooks/useNotificationList";

const NotificationList = ({ setNotificationShow }) => {
  const [data, setData] = useState({})
  const [deleteShow, setDeleteShow] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const { user } = useCurrentUser()
  const [dataLength, setDataLength] = useState({
    skip: 0,
    limit: 500
  })
  const navigate = useNavigate()
  const { notificationsData, isLoading } = useNotificationList(dataLength);

  useEffect(() => {
    if (notificationsData?.totalNotifications) {
      setData(notificationsData);
    }
  }, [notificationsData])

  const handleClose = () => {
    setDeleteShow(false)
  }

  const handleNotificationClick = async (notification, id) => {
    const response = await notificationService.readNotification(id)
    let url;
    if (["BID_NEGOTIATE_BY_PILOT", "JOB_START", "JOB_COMPLETE", "JOB_DISPUTE_RAISE", "BID_ACCEPTED_BY_PILOT", "NEW_BID", "JOB_INVITATION_BY_CLIENT"].includes(notification?.type) && notification?.data?.jobId) {
      url = `/my-jobs/${notification?.data?.jobId}`
    }
    else if (["BID_NEGOTIATE_BY_CLIENT", "BID_ACCEPTED_BY_CLIENT"].includes(notification?.type) && notification?.data?.bidId) {
      url = `/my-bids/${notification?.data?.bidId}`
    }
    else if (["NEW_JOB_AVAILABLE"].includes(notification?.type) && notification?.data?.jobId) {
      url = `/available-jobs`
    }
    else if (["DISASTER_ALERT", "DISASTER_CHARGE_REQUEST", "DISASTER_APPROVED", "DISASTER_REJECTED"].includes(notification?.type) && notification?.data?.emergencyId) {
      url = `/disasterdetails/${notification?.data?.emergencyId}`
    } else if (["MISSING_PERSON_ALERT", "MISSING_PERSON_CHARGE_REQUEST", "MISSING_PERSON_APPROVED", "MISSING_PERSON_REJECTED"].includes(notification?.type) && notification?.data?.emergencyId) {
      url = `/missingdetails/${notification?.data?.emergencyId}`
    } else if (["SPONSOR_REQUEST_CHARGE_REQUEST", "SPONSOR_REQUEST_APPROVED", "SPONSOR_REQUEST_REJECTED"].includes(notification?.type) && notification?.data?.sponsorRequestId) {
      url = `/advertisement/${notification?.data?.sponsorRequestId}`
    }
    url && navigate(url)
  }


  const handleViewMore = () => {
    setDataLength({
      ...dataLength,
      limit: dataLength?.limit + 50
    })
  }

  console.log(data?.notifications)
  return (
    <div className="container-box" style={{ minHeight: '100vh' }}>
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>
          <img src={arrowLeft} className="me-2 cursor-pointer" onClick={() => {
            navigate(-1);
          }} alt="" />Notification
        </h2>
      </div>
      <div className="notification-list-page bg-white px-4 mt-3 py-3" >
        {data?.notifications?.length > 0 ? (<>
          {data?.notifications?.map((item, i) => {
            return <>
              <div className="d-flex notify-outer justify-content-between align-items-center my-3 cursor-pointer gap-5 flex-wrap"
                style={{
                  background: item?.isRead === true ? '#fff' : '#e9f0f6',
                  boxShadow: item?.isRead === true ? '' : '',
                  border: item?.isRead !== true ? '' : 'none',
                }}
                onClick={() => handleNotificationClick(item, item?._id)}
              >
                <div >
                  <div className="d-flex user-div align-items-center gap-2">
                    {!item?.senderId?.avatar ? <img src={deafultuserImg} className="round-img" alt="" /> : <img src={`${user?.baseS3Url}${item?.senderId?.avatar}`} className="round-img" alt="" />}
                    <div>
                      <h6>{item?.title}</h6>
                      <p className="mb-0" style={{ maxWidth: '1200px', wordBreak: 'break-word' }}>{parse(item?.message)}</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-3 flex-wrap align-items-start">
                  <p className="light-text-hours"> {getFormattedDate(item?.created)}</p>
                  <RiDeleteBin4Line onClick={(e) => {
                    e.stopPropagation();
                    setDeleteShow(true)
                    setSelectedId(item?._id)
                  }} className="cursor-pointer" />
                </div>
              </div>
            </>
          })}
        </>) : (
          <>
            <div className="outer-white mission-div w-100 mx-auto">
              <div className="mt-2 ">
                <div className="disaster-card mx-auto text-center">
                  <div className="alert-distaster mx-auto">
                    <img src={star} alt="" />
                  </div >
                  <h2>No Notifications Available!</h2>
                </div >
              </div >
            </div >
          </>
        )}
      </div>
      {data?.notifications?.length < data?.totalNotifications && <div className="d-flex flex-wrap gap-2 justify-content-center my-4">
        <button className=" blue-btnnn text-white" onClick={handleViewMore}>
          View More
        </button>
      </div>}

      {deleteShow && selectedId && <DeleteNotification show={deleteShow} handleClose={handleClose} id={selectedId} data={data} setData={setData} />}


    </div>
  );
};

export default NotificationList;
